import React from 'react';
import { HeaderActionButtonContainer, StyledActionButton, StyledIcon } from './styled.js';

const HeaderActionButtons = (props) => {
  const { actionButtons } = props;

  return (
    <HeaderActionButtonContainer>
      {actionButtons.map(({ text, action, selected, selectedText, icon }, i) => (
        <StyledActionButton key={`header-action-${text}-${i}`} onClick={action} selected={selected}>
          {selected && icon && <StyledIcon icon={icon} />}
          {selected ? selectedText : text}
        </StyledActionButton>
      ))}
    </HeaderActionButtonContainer>
  );
};

export default HeaderActionButtons;
